import pluralize from 'pluralize'

const initialState = {
  total: 0,
}

const createVehicleMetaReducer =
  (entityName) =>
  (state = initialState, action) => {
    const pluralEntityName = pluralize(entityName, 2)

    switch (action.type) {
      case `FETCH_${pluralEntityName.toUpperCase()}_SUCCESS`:
        return {
          ...state,
          total: action.meta.total,
          makes: action.meta.makes,
          models: action.meta.models,
        }
      default:
        return state
    }
  }

export default createVehicleMetaReducer
